<template minapp='mpx' xlang='wxml'>
  <view class="container-header" bindtap="handleMoreClick">
    {{pageTitle}}
    <image wx:if="{{!disable}}" class="arrow" src="https://dpubstatic.udache.com/static/dpubimg/jv7ZfM1G_Bf66YjRFpS2U.png"></image>
    <!-- <view bindtap="debounceBefore"
      ><image
        class="day_text day_text_icon day_text_icon-left"
        wx:style="{{disableBefore ? 'opacity: 0.5': ''}}"
        src="https://img-hxy021.didistatic.com/static/starimg/img/eXi6G2uuPA1661505773975.png"
      ></image
    ></view>
    <view
      class="day_text before_day"
      wx:style="{{disableBefore ? 'opacity: 0.5': ''}}"
      bindtap="debounceBefore"
      >前一天</view
    > -->
    <!-- <view class="more" bindtap="handleMoreClick">
      <es-icon name="calendar-more" class="icon"></es-icon> -->
      <!-- <view class="day_text">{{ dateTextShow.dateText }} {{ dateTextShow.weekText }}</view> -->
    <!-- </view> -->
    <!-- <view
      class="day_text after_day"
      wx:style="{{disableAfter ? 'opacity: 0.5': ''}}"
      bindtap="debounceAfter"
      >后一天</view
    >
    <view bindtap="debounceAfter"
      ><image
        class="day_text day_text_icon day_text_icon-right"
        wx:style="{{disableAfter ? 'opacity: 0.5': ''}}"
        src="https://img-hxy021.didistatic.com/static/starimg/img/KUsheHvww11661506773652.png"
      ></image
    ></view> -->
  </view>
  <es-popup show="{{ show }}" closeable="{{closeable}}" bind:close="onClose" position="bottom">
    <es-calendar
      value="{{innerVal}}"
      disabled="{{disabled}}"
      type="{{checkType}}"
      title="{{title}}"
      formatter="{{formatter}}"
      color="{{color}}"
      show-confirm="{{showConfirm}}"
      start-text="{{startText}}"
      end-text="{{endText}}"
      confirm-text="{{confirmText}}"
      first-day="{{firstDay}}"
      max-range="{{maxRange}}"
      maxDate="{{innerMaxDate}}"
      minDate="{{innerMinDate}}"
      format="{{format}}"
      allow-same-day="{{allowSameDay}}"
      bind:confirm="onConfirm"
      bind:input="onInput"
    >
    </es-calendar>
  </es-popup>
</template>
<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { getFullDate } from '@didi/es-mpx-shared/lib/date'
  import { formatDate } from '@didi/es-mpx-shared/lib/date'
  import { getDayByOffset, compare } from '@didi/es-mpx-shared'
  import { getStorage, setStorage } from '@/utils/storage'
  import { STORAGE_LIST_SEARCH_QUERY } from '@/utils/train-storage'
  import { isToday, isTomorrow } from '@/utils/baseDate'
  createComponent({
    classes: ['caldendar-date-style'],
    props: {
      // 默认值 timestamp | timestamp[],传到e组件里面的value
      value: {
        type: Array,
        optionalTypes: [Number, String]
      },
      // 选定时间的前后可选时间
      checkRange: {
        type: Number,
        value: 7
      },
      // 设置日期格式
      dateType: {
        type: String,
        value: 'MM-dd'
      },
      // 最大时间
      maxHeaderDate: null,
      // 最小时间
      minHeaderDate: null,
      // 是否联动
      linking: {
        type: Boolean,
        value: false
      },
      // 是否每次点击等多都要更新
      isUpdateEveryTime: {
        type: Boolean,
        value: false
      },
      // 设置是否可选
      disabled: Boolean,
      // 日历类型 range|single|multiple
      checkType: String,
      // 是否展示弹层的 [x]
      closeable: {
        type: Boolean,
        value: false
      },
      // 标题
      title: String,
      // 自定义时间格式化
      formatter: null,
      // 选中底色
      color: String,
      // 是否显示底部确定按钮
      showConfirm: Boolean,
      // 起始选中文案
      startText: String,
      // 终止选中文案
      endText: String,
      // 底部按钮文案
      confirmText: String,
      // 起始周
      firstDay: Number,
      // 可选择最小时间
      minDate: Number,
      // 可选择最大时间
      maxDate: Number,

      format: null,
      // 多选最多可以选几个
      maxRange: Number,
      allowSameDay: Boolean,
      disable: {
        type: Boolean,
        value: true
      }
    },
    data: {
      days: [],
      chosed: 0,
      pre_chosed: 0,
      show: false,
      showDialog: false,
      innerVal: [],
      innerMaxHeaderDate: undefined,
      innerMinHeaderDate: undefined,
      // scrollLeft:0,
      transformVal: 0,
      isOnedarger: false,
      dateTextShow: '',
      beforeDay: 0,
      afterDay: 0,
      today: 0,
      disableBefore: false,
      disableAfter: false,
      endTime: 0,
      lastTime: 0
    },

    computed: {
      innerMaxDate() {
        return this.maxDate
          ? this.maxDate
          : new Date().setHours(0, 0, 0, 0) + 1000 * 60 * 60 * 24 * 365
      },
      innerMinDate() {
        return this.minDate ? this.minDate : new Date().setHours(0, 0, 0, 0)
      },
      pageTitle() {
        let title = this.dateTextShow?.dateText
        const selectTime = this.dateTextShow?.timeStamp
        if(isToday(selectTime)) {
          title += ' 今日出发'
        } else if(isTomorrow(selectTime)) {
          title += ' 明日出发'
        }
        return title
      }
    },

    created() {
      this.innerVal = Array.isArray(this.value) ? this.value.slice() : [this.value]
      // this.dateTextShow = this.getDays(this.innerVal[0])
      const trainListSearchQuery = getStorage(STORAGE_LIST_SEARCH_QUERY) || {}
      const val = new Date(trainListSearchQuery.train_date).getTime() || new Date().getTime()
      this.dateTextShow = this.getDays(val)
      this.innerMaxHeaderDate = this.maxHeaderDate
      this.innerMinHeaderDate = this.minHeaderDate

      this.initDays()
    },
    mounted() {},

    watch: {
      value(val) {
        this.$nextTick(() => {
          const arr = Array.isArray(val) ? val.slice() : [val]
          this.innerVal = arr.sort()
          this.initDays()
        })
      },
      maxHeaderDate(val) {
        this.innerMaxHeaderDate = val ? new Date(val).setHours(0, 0, 0, 0) : null
        this.initDays()
      },
      minHeaderDate(val) {
        this.innerMinHeaderDate = val ? new Date(val).setHours(0, 0, 0, 0) : null
        this.initDays()
      }
      // afterDayDisabled(val) {
      //   this.disableAfter = val
      // },
    },

    methods: {
      changeType() {
        this.isActive = !this.isActive
      },
      onClose() {
        this.show = false
      },
      handleBeforeDay(that) {
        if (that.disableBefore) {
          return
        }
        this.$trigger('reportClick', 'before_day')
        let data = {
          detail: [that.beforeDay]
        }

        that.onConfirm(data)
      },

      handleAfterDay(that) {
        if (that.disableAfter) {
          return
        }
        this.$trigger('reportClick', 'next_day')
        let data = {
          detail: [that.afterDay]
        }
        that.onConfirm(data)
      },
      throttle(func, wait, that) {
        let now = Date.now()
        if (now - this.lastTime > wait) {
          this.lastTime = now
          func(that)
        }
      },
      debounceBefore() {
        this.throttle(this.handleBeforeDay, 800, this)
      },
      debounceAfter() {
        this.throttle(this.handleAfterDay, 800, this)
      },
      getDays(timeStamp, canCheck) {
        const weeks = ['日', '一', '二', '三', '四', '五', '六']
        const { week, day } = getFullDate(timeStamp)
        const item = {
          canCheck,
          timeStamp,
          weekText: '周' + weeks[week],
          dateText: formatDate(timeStamp, this.dateType)
        }
        return item
      },

      range(min, max) {
        let times = []
        let start = new Date(min)
        let end = new Date(max)
        end.setHours(0, 0, 0, 0)
        start.setHours(0, 0, 0, 0)
        let initIndex = 0
        while (start.getTime() <= end.getTime()) {
          if (new Date(this.innerVal[0]).setHours(0, 0, 0, 0) === start.setHours(0, 0, 0, 0)) {
            this.chosed = initIndex
            this.pre_chosed = initIndex
          }
          initIndex++
          times.push(this.getDays(start.getTime(), true))
          start.setDate(start.getDate() + 1)
        }

        while (initIndex < 5) {
          initIndex++
          times.push(this.getDays(start.getTime(), false))
          start.setDate(start.getDate() + 1)
        }
        return times
      },

      initDays() {
        // 对传入的value处理

        let today = new Date().setHours(0, 0, 0, 0)
        this.today = today
        // 选中日期起止
        let endTime = this.innerMaxHeaderDate
        let startTime = this.innerMinHeaderDate
        // 如果minHeaderDate和maxHeaderDate都传了则优先
        this.beforeDay = this.innerVal[0] - 1000 * 60 * 60 * 24
        this.afterDay = this.innerVal[1] || this.innerVal[0] + 1000 * 60 * 60 * 24
        if (!endTime || !startTime) {
          startTime = startTime || this.innerVal[0] - 1000 * 60 * 60 * 24 * this.checkRange
          endTime =
            endTime || this.innerVal[1] || this.innerVal[0] + 1000 * 60 * 60 * 24 * this.checkRange
        }
        this.endTime = endTime

        // 不取今天之前
        if (startTime < today) {
          startTime = today
        }
        let before_day = new Date(this.beforeDay).setHours(0, 0, 0, 0)
        let todaySetHour = new Date(this.today).setHours(0, 0, 0, 0)
        let minDaySetHour = new Date(this.innerMinDate).setHours(0, 0, 0, 0)
        let maxDaySetHour = new Date(this.innerMaxDate).setHours(0, 0, 0, 0)
        if (before_day < minDaySetHour || before_day < todaySetHour) {
          this.beforeDay = compare(before_day, minDaySetHour) >= 0 ? before_day : minDaySetHour
          this.disableBefore = true
        } else {
          this.disableBefore = false
        }

        let after_day = new Date(this.afterDay).setHours(0, 0, 0, 0)
        let dateNow = new Date(Date.now()).setHours(0, 0, 0, 0)

        const compareTime = compare(getDayByOffset(dateNow, 14).getTime(), maxDaySetHour)
        if (compareTime > 0 && after_day > maxDaySetHour) {
          this.afterDay = this.innerMaxDate

          this.disableAfter = true
        } else if (compareTime <= 0 && after_day > getDayByOffset(dateNow, 14).getTime()) {
          this.afterDay = getDayByOffset(dateNow, 15).getTime()
          this.disableAfter = false
        } else {
          this.disableAfter = false
        }
        // 车次列表搜索参数更新

        this.days = this.range(startTime, endTime)
      },

      // 选中的值与range的值比较，取InnerVal
      getInnerVal() {
        const checkdeTime = this.days[this.chosed].timeStamp
        let [setMin, setMax] = this.value
        if (!!setMax && checkdeTime > setMax) {
          setMax = checkdeTime
        }
        return [checkdeTime, setMax]
      },

      handleClickDay(index, item) {
        if (item.canCheck) {
          this.pre_chosed = this.chosed
          this.chosed = index
        }
        this.$nextTick(() => {
          this.$trigger('handleClickDay', { data: this.getInnerVal(), canCheck: item.canCheck })
        })
      },

      // 返回上一个选择
      returnToPre() {
        setTimeout(() => {
          this.chosed = this.pre_chosed
        }, 500)
        this.$nextTick(() => {
          this.$trigger('returnToPre', this.getInnerVal())
          const date = new Date(this.getInnerVal()[0]).setHours(8)
          // this.disableAfter =
          //   compare(getDayByOffset(Date.now(), 13).getTime(), date) >= 0 ? false : true
          this.dateTextShow = this.getDays(this.getInnerVal()[0])
        })
      },
      // 点击打开日历
      handleMoreClick() {
        if(this.disable) return 
        this.show = true
        let [min, max] = this.getInnerVal()
        if (this.isUpdateEveryTime) {
          min = +min + Math.floor(Math.random() * (100 - 1)) + 1
        }
        this.innerVal = [min, max]
        this.$trigger('reportClick', 'date')
      },
      // 底部点击事件
      onConfirm(data) {
        this.show = false
        this.$trigger('confirm', data.detail)
        // this.dateTextShow = this.getDays(data.detail[0])
        this.$nextTick(() => {
          if (this.linking) {
            const [min, max] = data.detail
            // 如果是限制最大是返程时间，那么返回的时候更新最大时间
            this.innerMaxHeaderDate = max && this.maxHeaderDate ? max : this.maxHeaderDate
            this.innerVal = [min, max]
            this.dateTextShow = this.getDays(data.detail[0])
            this.initDays()
          }
        })
      },
      // 每次点击触发value
      onInput(data) {
        this.$nextTick(() => {
          this.$trigger('input', data.detail)
        })
      }
    }
  })
</script>

<style lang="stylus" scoped>
  .container-header
    display flex
    justify-content center
    align-items center
    // height 36px
    // margin-right 12px
    // background rgba(60, 90, 134, 0.06)
    // border-radius 8px
    // margin-left 12px
    font-size 18px
    font-family PingFangSC-Medium
    color #333333
  .arrow
    width 12px
    height 6px
    margin-left 6.5px
  // .day_text
  //   font-family PingFangSC-Regular
  //   font-size 14px
  //   color #10294D
  //   text-align center
  //   font-weight 400
  //   line-height 36px
  // .day_text_icon
  //   width 12px
  //   height 12px
  //   margin-top 4px
  // .before_day
  //   margin-right auto
  // .after_day
  //   margin-left auto
  // // .week
  // // font-size 11px
  // // font-family Ping Fang SC
  // // font-weight 400
  // // .calendar
  // // display flex
  // // height 100%
  // // flex-wrap nowrap
  // // flex-direction row
  // // .calendar-item
  // // display flex
  // // width 62px
  // // height 44px
  // // flex-shrink 0
  // // flex-direction column
  // // justify-content center
  // // text-align center
  // // box-sizing border-box
  // // .isActived
  // // color #ffffff
  // // border-radius 6px
  // // background #1473FF
  // // .noCheck
  // // color #BBBBBB
  // .more
  //   // position absolute
  //   // left calc(50% - 31px)
  //   // width 62px
  //   // height 44px
  //   display flex
  //   flex-direction row
  //   justify-content center
  //   align-items center
  //   text-align center
  //   // box-shadow -1px 0px 10px rgba(73,84,100,0.16)
  //   font-weight 400
  //   // background #ffffff
  // .icon
  //   width 18px
  //   height 18px
  //   font-size 18px
  //   margin 2px
  //   color #10294D
  // .day_text_icon-left
  //   margin-left 12px
  //   margin-right 7px
  // .day_text_icon-right
  //   margin-left 7px
  //   margin-right 12px
</style>

<script name='json'>
  module.exports = {
    navigationBarTitleText: '日期选择',
    component: true,
    usingComponents: {
      'es-popup': '@didi/es-mpx-ui/lib/popup',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-calendar': '@/components/calendar',
    }
  }
</script>
